<template>
    <div class="edit-card">
        <div class="edit-card__container spacing-b-6">
            <TitleText class="spacing-b-6" level="2">
                {{ $ml.get('editCardTitle') }}
            </TitleText>

            <SelectedCard class="spacing-b-12" :hide-actions="true" />

            <TitleText class="spacing-b-6" level="2">
                {{ $ml.get('billingAddress') }}
            </TitleText>

            <div class="edit-card__checkbox-container">
                <CieloCheckBoxV2
                    class="justify-content-start"
                    v-model="billingAddressTypeCheckbox"
                    :clickable-slot="true"
                    :text-aria="$ml.get('billingAddressTypeCheckbox')"
                >
                    <span v-text="$ml.get('billingAddressTypeCheckbox')" />
                </CieloCheckBoxV2>
                <InfoTooltip
                    :items="['billingAddressTypeTooltip']"
                    :orientation="renderMobile() ? 'left' : 'top'"
                    icon-color="gray"
                />
            </div>

            <Address
                ref="dof-billing-address"

                :zip-code.sync="localBillingAddress.zipCode"
                :street.sync="localBillingAddress.street"
                :number.sync="localBillingAddress.number"
                :complement.sync="localBillingAddress.complement"
                :district.sync="localBillingAddress.district"
                :city.sync="localBillingAddress.city"
                :state.sync="localBillingAddress.state"

                :disable-street="disableStreet"
                :disable-district="disableDistrict"
                :disable-city="disableCity"
                :disable-state="disableState"

                :address-errors.sync="addressErrors"

                @postalCodeFetched="onZipCodeFetched"
            />
        </div>

        <div class="edit-card__cta-container">
            <ButtonsNextPreviousV2
                :disable-button-next="disableButtonSaveAndContinue"
                :loading="loading"
                :back-text="'cancel'"
                :next-text="'saveAndContinue'"
                @click-next="saveAndContinue"
                @click-previous="goToPreviousStep"
            />
        </div>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex';

    import { isMobile } from '@/helpers/isMobile';
    import { isNullOrWhitespace } from '@/helpers/stringHelper';

	import TitleText from '@/components/template/TitleText';
    import Address from '@/components/Address';
    import CieloCheckBoxV2 from '@/components/ClickToPay/template/CieloCheckBoxV2';
    import InfoTooltip from '@/components/InfoTooltip';
    import ButtonsNextPreviousV2 from '@/components/template/ButtonsNextPreviousV2';
    import SelectedCard from '../components/SelectedCard';

	export default {
		components: {
			TitleText,
            Address,
            CieloCheckBoxV2,
            InfoTooltip,
            ButtonsNextPreviousV2,
            SelectedCard
		},

		data() {
			return {
				localBillingAddress: {},
                addressErrors: {},
                fetchedAddressFields: [],
                billingAddressTypeCheckbox: false,
                loading: false,
			};
		},

		created() {
			this.localBillingAddress = JSON.parse(JSON.stringify(this.selectedCard.billingAddress));
        },

		mounted() {
            this.billingAddressTypeCheckbox = !this.isNational;
        },

        watch: {
            billingAddressTypeCheckbox(newVal) {
                const type = newVal ? 'foreign' : 'national';
                this.$store.commit('billingAddress/setType', type);
            },
        },

		computed: {
			...mapGetters({
				selectedCard: 'dataOnFile/getSelectedCard',
                isNational: 'billingAddress/getIsNational'
			}),

            disableStreet: self => false,
            disableDistrict: self => false,
            disableCity: self => self.fetchedAddressFields.includes('city'),
            disableState: self => self.fetchedAddressFields.includes('state'),

            disableButtonSaveAndContinue() {
                return false;
            },
		},

		methods: {
            renderMobile() {
                return isMobile();
            },

            onZipCodeFetched(data) {
                this.fetchedAddressFields = [];
                if (!data) return;

                this.localBillingAddress.street = data.fields.Street;
                this.localBillingAddress.number = data.fields.Number || null;
                this.localBillingAddress.complement = data.fields.Complement || null;
                this.localBillingAddress.district = data.fields.District;
                this.localBillingAddress.city = data.fields.City;
                this.localBillingAddress.state = data.fields.State;

                if(isNullOrWhitespace(this.localBillingAddress.street) == false)
                    this.fetchedAddressFields.push('street');
                if(isNullOrWhitespace(this.localBillingAddress.district) == false)
                    this.fetchedAddressFields.push('district');
                if(isNullOrWhitespace(this.localBillingAddress.city) == false)
                    this.fetchedAddressFields.push('city');
                if(isNullOrWhitespace(this.localBillingAddress.state) == false)
                    this.fetchedAddressFields.push('state');
            },

            goToPreviousStep() {
                this.$store.dispatch('pipelineV2/pushTo', 'DataOnFileReview');
            },

            async saveAndContinue() {
                if(this.loading) return;
                this.loading = true;
                
                await this.$refs['dof-billing-address'].validateAddress();

                if (this.addressErrors.items && this.addressErrors.items.length > 0) {
                    this.loading = false;
                    return;
                }

                try {
                    await this.$store.dispatch('dataOnFile/editCardBillingAddress', this.localBillingAddress);
                    this.$store.dispatch('pipelineV2/pushTo', 'DataOnFileReview');
                } catch (error) {
                    // TODO: tratar o erro na view?
                    console.error(error);
                } finally {
                    this.loading = false;
                }
            },
		},
	};
</script>

<style scoped lang="scss">
    .edit-card {

        &__checkbox-container {
            display: flex;
            gap: 8px;
            margin-bottom: 20px;
        }
    }
</style>
